import Vue from 'vue';
import VueI18n from 'vue-i18n';
import vuex from '../store';
import en from './en-US.json';
import de from './de-DE.json';
import nl from './nl-NL.json';
import cz from './cs-CZ.json';
import czen from './en-CZ.json';
import czde from './de-CZ.json';

Vue.use(VueI18n);
let isCzechInstance = location.hostname === 'voucher.animod.cz' || location.search.indexOf('czech=true') !== -1;

const i18n = new VueI18n({
    locale: vuex.state.locale,
    fallbackLocale: 'de-DE',
    messages: {
        ['en-US']: isCzechInstance ? czen : en,
        ['de-DE']: isCzechInstance ? czde : de,
        ['nl-NL']: nl,
        ['cs-CZ']: cz
    }
});

function flattenObject(ob) {
    var toReturn = {};

    for (var i in ob) {
        if (!ob.hasOwnProperty(i)) continue;

        if ((typeof ob[i]) == 'object' && ob[i] !== null) {
            var flatObject = flattenObject(ob[i]);
            for (var x in flatObject) {
                if (!flatObject.hasOwnProperty(x)) continue;

                toReturn[i + '.' + x] = flatObject[x];
            }
        } else {
            toReturn[i] = ob[i];
        }
    }
    return toReturn;
}

export default i18n;
